import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { UserRol } from '@ciptech/classes';
import { AuthenticatedGuard, RolGuard } from '@ciptech/commons';
import { BrowserPrintComponent } from './features/browser-print/browser-print.component';

const routes: Routes = [
	{
		path: '',
		// pathMatch: 'full',
		loadChildren: () => import('./features/portal/portal.module').then(m => m.PortalModule)
	},
	{
		path: 'auth',
		loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
	},
	{
		path: 'admin',
		canActivate: [AuthenticatedGuard, RolGuard],
		canLoad: [AuthenticatedGuard, RolGuard],
		data: { rols: [UserRol.admin], authRefresh: true },
		loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule)
	},
	{
		path: 'encuesta',
		loadChildren: () => import('./features/encuesta/encuesta.module').then(m => m.EncuestaModule)
	},
	{ path: 'not-found', component: NotFoundComponent },
	{ path: 'browser', component: BrowserPrintComponent },
	{ path: '**', component: NotFoundComponent }
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
